import { useState } from "react";
import {
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  TextField,
} from "../../../../components";
import { value } from "../../../../helpers";
import { notification, PdvOfflineService } from "../../../../services";
import { responseErros } from "../../../../utils";

const pdvOfflineService = new PdvOfflineService();

const PdvOfflineSerieDialog = ({
  open,
  setOpen,
  pdvOffline,
  setPdvOffline,
  setLoading,
  buscaOperacaoFiscal,
}) => {
  const [erro, setErro] = useState(false);

  const handleClose = () => {
    setErro(false);
    setOpen(false);
  };

  const handleInputChange = (event) => {
    setPdvOffline((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const onClickSalvar = async () => {
    if (!pdvOffline.serie || !pdvOffline.numeroDocumento) {
      setErro(true);
      return;
    }
    setErro(false);
    setLoading(true);
    const response = await pdvOfflineService.atualizar(pdvOffline.id, {
      serie: pdvOffline.serie,
      numeroDocumento: pdvOffline.numeroDocumento,
    });
    setLoading(false);
    if (!response.isAxiosError) {
      notification.alteracaoSucesso();
      buscaOperacaoFiscal();
      setOpen(false);
    } else {
      responseErros(response);
    }
  };

  return (
    <Dialog maxWidth="xs" fullWidth open={open} onClose={handleClose}>
      <DialogContent>
        <CardHeader title="Editar Série PDV Offline" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="nome"
                name="nome"
                label="Nome"
                variant="filled"
                value={value.text(pdvOffline?.nome)}
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="serie"
                name="serie"
                label="Série"
                variant="outlined"
                value={value.text(pdvOffline?.serie)}
                onChange={handleInputChange}
                error={erro}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="numeroDocumento"
                name="numeroDocumento"
                label="Número do Documento"
                variant="outlined"
                error={erro}
                value={value.text(pdvOffline?.numeroDocumento)}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button variant="contained" color="primary" onClick={onClickSalvar}>
            <i
              className="ph-fill ph-check-circle"
              style={{ color: "white", fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button variant="contained" color="padrao" onClick={handleClose}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </DialogContent>
    </Dialog>
  );
};

export default PdvOfflineSerieDialog;
